import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsTransportadoraClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/transportadora');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Transportadora');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/transportadora', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Transportadora');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/transportadora', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Transportadora');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/transportadora/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Transportadora');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.post('/transportadora/update', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Transportadora');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/transportadora/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Transportadora');
    }
  }
}
